import { EventEmitter } from '@angular/core';

// Use require for CommonJS module compatibility
// tslint:disable-next-line:no-var-requires
const intlTelInputModule = require('intl-tel-input');
// Handle both default export and direct export
const intlTelInput = intlTelInputModule.default || intlTelInputModule;

export function buildIntlTelInput(input: HTMLInputElement, countryCode: string) {
  if (!intlTelInput || typeof intlTelInput !== 'function') {
    console.error('intlTelInput is not a function', intlTelInput);
    throw new Error('intl-tel-input library failed to load. Please ensure it is properly installed.');
  }

  const intlTel = intlTelInput(input, {
    initialCountry: countryCode,
    separateDialCode: true,
    nationalMode: false,
    formatOnDisplay: false,
    countrySearch: true,
    utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js',
  } as any);

  return intlTel;
}

export function configureIntlTelInputListener(input, intlTel, countryCodeChange: EventEmitter<string>, maskRef) {
  input.addEventListener('countrychange', (_) => {
    const countryCodeValue = getCountryCodeValue(intlTel);

    countryCodeChange.emit(countryCodeValue);

    updateMask(intlTel, maskRef);
  });
}

export function updateMask(intlTel, maskRef) {
  const countryCodeValue = getCountryCodeValue(intlTel);
  const maskOptions = selectRightMask(countryCodeValue);

  maskRef.updateValue();

  // Only apply mask for US (+1 dial code)
  // For non-US countries, we don't apply any mask formatting
  if (maskOptions) {
    maskRef.updateOptions(maskOptions);
  }
  // If maskOptions is null (non-US), we don't update - the initial undefined mask remains
}

export function getCountryCodeValue(intlTel) {
  return `+${intlTel?.getSelectedCountryData()?.dialCode}`
}

function selectRightMask(phoneCountryCode) {
  const usDialCode = '+1';
  const usMask = '(000) 000-0000';

  // Only apply mask for US (+1), return null for other countries (no mask)
  return phoneCountryCode === usDialCode ?
    { mask: usMask } :
    null;
}

export function getMaskFromCountryCode(countryCode: string | any) {
  // If it's already a mask object, return it as is
  if (typeof countryCode === 'object' && countryCode !== null && countryCode.mask) {
    return countryCode;
  }

  // If it's a country code string, check if it's US
  if (typeof countryCode === 'string') {
    const upperCountryCode = countryCode.toUpperCase();
    if (upperCountryCode === 'US' || upperCountryCode === '+1') {
      return { mask: '(000) 000-0000' };
    }
  }

  // For non-US countries or no country code, return undefined (no mask)
  // The actual mask will be set by updateMask() based on the dial code from intlTelInput
  return { mask: '00000000000000000' };
}

export function checkFocused(flagsContainer: HTMLElement) {
  if (!!flagsContainer) {
    toggleFlagContainerVisibility('block', flagsContainer);
  }
}

export function checkFocusedout(e, flagsContainer: HTMLElement, isInputEmpty: boolean) {
  const inputEvent = e.relatedTarget;
  const isClickOnFlag = checkClass(inputEvent, 'iti__selected-country') || checkClass(inputEvent, 'iti__country') || checkClass(inputEvent, 'iti__search-input');

  if (isInputEmpty && !isClickOnFlag && !!flagsContainer) {
    /* toggleFlagContainerVisibility('none', flagsContainer); */
  }
}

function checkClass(element: HTMLElement, klass: string) {
  return element?.classList.contains(klass);
}

export function toggleFlagContainerVisibility(display: string, flagsContainer: HTMLElement) {
  if (flagsContainer) {
    flagsContainer.style.display = display;
  }
}

export function shouldValidate(intlTel) {
  return !intlTel?.isValidNumber();
}

export function destroyInput(intlTel) {
  return intlTel?.destroy();
}

export function setInputValue(intlTel, value) {
  intlTel.setNumber(value);
}

export function parsePhoneNumber(value): string {
  const parsedValue = value.replace(/[^\d+]/g, '');
  return '+' + parsedValue;
}
